// Module
var code = "<ui-view> <record-grid-view grid-data-source=\"stateController.gridDataSource\" grid-settings=\"stateController.gridSettings\" columns=\"stateController.columns\" default-query=\"stateController.defaultQuery\" name-singular=\"'Process Template'\" name-plural=\"'Process Templates'\" default-sort=\"'Type'\"> </record-grid-view> </ui-view> ";
// Exports
export default code;